export const GENERIC_GLOBAL = 'global.generic';
export const PDP_PLCC_LABELS = 'Browse.PDP';
export const LOYALTY_GLOBAL = 'global.loyalityBanner';

export const globalGenericLabels = {
  global: {
    generic: {
      lbl_creditCard: 'Credit Card',
    },
    loyalityBanner: {
      lbl_loyaltyBanner__fancy_estimatedSubtotal: 'Your New Estimated Subtotal With Card:',
    },
  },
};

export const pdpPLCCBannerLabelsData = {
  Browse: {
    PDP: {
      lbl_PLCC_reward_multiclr:
        '<span style="color:#e86726;font-weight:900">MY</span> <span style="color:#00a7e0;font-weight:900">PLACE</span> <span style="color:#e2499b;font-weight:900">REWARDS</span>',
      lbl_banner_pdp_plcc_rewards_label:
        'Earn <span style="color:#00a7e0">2X</span> Points everyday when you checkout with your',
      lbl_banner_pdp_mpr_rewards_label:
        'Earn <span style="color:#e86726">2X</span> Points Everyday with',
      lbl_banner_pdp_guest_rewards_label1: '<span style="font-weight:700">Get Rewarded!</span>',
      lbl_banner_pdp_guest_rewards_label2:
        '$1 SPENT = 1 POINT | 100 POINTS = <span style="font-weight:700">$5 REWARD<span>',
    },
  },
};
